var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.12823 0.154825C3.33354 -0.0516075 3.66646 -0.0516075 3.87178 0.15482L6.84601 3.14501C7.05133 3.35144 7.05133 3.68613 6.84601 3.89255C6.64068 4.09897 6.30778 4.09897 6.10245 3.89255L4.02578 1.80474V8.80474C4.02578 9.09668 3.79039 9.33333 3.5 9.33333C3.20962 9.33333 2.97423 9.09668 2.97423 8.80474V1.80474L0.897587 3.89255C0.69222 4.09897 0.359353 4.09897 0.153986 3.89255C-0.0513282 3.68613 -0.0513282 3.35144 0.153986 3.14501L3.12823 0.154825Z",
    fill: "#2C8C53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrowUp);
export default __webpack_public_path__ + "static/media/greenArrowUp.260ddc1ab39cd76d5b6f69c34b36086b.svg";
export { ForwardRef as ReactComponent };